<template>
  <header class="header fixed-top clearfix">
    <!--logo start-->
    <div class="brand">
      <div class="topleft">
        <a href="javascript:;">
          <img :src="logo" :title="title">
        </a>
      </div>
      <div class="sidebar-toggle-box" v-if="groupLength > 0 ">
        <div id="sidebar-toggle" class="fa fa-bars el-icon-menu" title="菜单显隐"/>
      </div>
    </div>
    <!--logo end-->
    <div class="top-nav clearfix">
      <!--search & user info start-->
      <div class="header-1200">
        <ul class="nav">
          <li v-for="item in menu.main" :key="item.id">
            <a
              :href="item.href"
              :class="{selected: item.current == 1, is_dev: !$isOnline}"
              target="_blank"
            >
              <h2>{{ isInterviewSite ? $t(item.title) : item.title }}</h2>
            </a>
          </li>
        </ul>
        <div class="topright" v-if="userinfo.userid">
          <ul>
            <li class="msg-number-box">
              <router-link :to="{ name: 'remind' }">
                <el-badge :value="messageCount" :max="100" class="item" >
                  <img src="../../assets/ui2020/icon-ring.png" alt="消息提醒" >
                </el-badge>
              </router-link>
            </li>
            <li class="msg-avatar-area">
              <router-link v-if="$siteName === 'teaching'" class="avatar-box" :to="{ name: 'teacherEdit', params: { uid: userinfo.userid } }">
                <img
                  :title="`管理员ID：${userinfo.userid}\n角色ID：${userinfo.roleids.join(', ')}`"
                  class="header_tx"
                  :src="userinfo.touxiang ? `${$jiemo.imghome}${userinfo.teachingInfo.portrait}` : defaultAvatar"
                  width="34"
                  height="34"
                >
              </router-link>
              <router-link v-else class="avatar-box" :to="{ name: 'account' }">
                <img
                  :title="`管理员ID：${userinfo.userid}\n角色ID：${userinfo.roleids.join(', ')}`"
                  class="header_tx"
                  :src="userinfo.touxiang ? `${$jiemo.imghome}/Upload/teacher/${userinfo.touxiang}` : defaultAvatar"
                  width="34"
                  height="34"
                >
              </router-link>
              <router-link v-if="$siteName === 'teaching'" :to="{ name: 'teacherEdit', params: { uid: userinfo.userid } }">{{ userinfo.teachingInfo.truename }}</router-link>
              <router-link v-else :to="{ name: 'account' }">{{ userinfo.username }}</router-link>
            </li>
            <li v-if="$siteName === 'interview'">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">{{ currentLocalName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-plus" @click.native="changeLocal">{{ localName }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <li>
              <a href="#" @click="logout" class="header_exit">{{ $t('message.logout') }}</a>
            </li>
          </ul>
        </div>
      </div>
      <!--search & user info end-->
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import Lockr from 'lockr';
import siteInfo from '@/siteInfo';

export default {
  name: 'JmHeader',
  props: {
    site: {
      type: String,
      default: 'fib'
    }
  },
  data() {
    return {
      groupLength: '',
      localName: '日本語',
      currentLocalName: '中文',
      notifyBubble: null,
    };
  },
  mounted() {
    const local = Lockr.get('local');
    if (local === 'ja') {
      this.localName = '中文';
      this.currentLocalName = '日本語';
    }
  },
  methods: {
    logout() {
      Lockr.set('jwt', null);
      Lockr.flush();
      this.$http._get({
        url: '/index/api_base/logout'
      });
      return false;
    },
    changeLocal() {
      const temp = this.localName;
      this.localName = this.currentLocalName;
      this.currentLocalName = temp;
      this.$store.commit('setLocal', temp);
      Lockr.set('local', (temp === '日本語') ? 'ja' : 'zh');
      window.location.reload();
    },
  },
  computed: {
    ...mapState(['menu', 'userinfo', 'messageAmount', 'bubbleCount']),
    /**
     * 消息数目
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Number} [description]
     */
    messageCount() {
      if (this.messageAmount === null) {
        return Lockr.get('notifyMessageAmount');
      }
      Lockr.set('notifyMessageAmount', this.messageAmount);
      return this.messageAmount;
    },
    logo() {
      const info = siteInfo[this.site];
      // eslint-disable-next-line
      return require(`@/assets/logo/${info.logo}`);
    },
    defaultAvatar() {
      // eslint-disable-next-line
      return require(`@/assets/images/icon-avatar-default.png`);
    },
    title() {
      return siteInfo[this.site].title;
    }
  },
  watch: {
    menu(value) {
      if (value.child && value.child.length) {
        this.groupLength = value.child.length;
      }
    },
    bubbleCount(value) {
      console.log(`您有${value}条线索做了购买动作`);
      this.notifyBubble && this.notifyBubble.close();
      this.notifyBubble = this.$notify({
        message: `您有${value}条线索做了购买动作`,
        position: 'top-right',
        duration: 0,
        offset: 65,
        onClick: () => {
          if (this.$siteName === 'training') {
            this.$router.push({ name: 'Plantasklist', params: { searchType: 'visit-5' } });
          } else {
            this.$router.push({ name: 'remind' });
          }
          this.notifyBubble.close();
        }
      });
    }
  }
};
</script>
<style>
.el-notification{
  cursor:pointer;
}
.is_dev h2 {
  color: red !important;
}
.el-badge img {
  width: 50px;
  display: inline-block;
  vertical-align: middle;
}
.tip-link {
  margin-right: 15px;
}
#header {
  width: 100%;
  height: 80px;
  background: #01142d;
  position: relative;
  z-index: 1;
}
.header-1200 {
  min-width: 1200px;
  margin: 0 auto;
}
.topleft {
  height: 80px;
  float: left;
  width: 200px;
  /*text-align: center;*/
  padding-left: 28px;
}
.nav {
  float: left;
  margin-left: 30px;
}
.topright {
  height: 80px;
  float: right;
  color: #fff;
}
.nav li {
  float: left;
  width: auto;
  text-align: center;
}
.nav li a {
  display: block;
  padding: 0 15px;
  transition: background-color 0.3s linear;
  -moz-transition: background-color 0.3s linear;
  -webkit-transition: background-color 0.3s linear;
  -o-transition: background-color 0.3s linear;
}
.nav li a:hover {
  display: block;
  color: #fff;
  background: none repeat scroll 0 0 rgb(43, 127, 181);
  border-bottom: 3px solid #55acee;
}
.nav a h2 {
  font-size: 16px;
  color: #fff;
  line-height: 77px;
}
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.nav li a.selected {
  border-bottom: 3px solid #55acee;
}
.topleft img {
  margin-top: 17px;
}
.topright ul {
  height: 80px;
  line-height: 80px;
  float: right;
  padding-right: 12px;
}
.topright ul li {
  float: left;
  padding-left: 14px;
  padding-right: 14px;
}

.topright ul li a {
  font-size: 13px;
  color: #e9f2f7;
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
}
.header_exit {
  display: inline !important;
  border: 1px solid #fff;
  padding: 3px 15px;
  border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
}
.user {
  height: 30px;
  margin-top: 21px;
  float: right;
  margin-right: 12px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  border-radius: 30px;
  white-space: nowrap;
  position: relative;
}
.header_tx {
  width: 34px;
  height: 34px;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  border-radius: 100%;
  -moz-border-radius: 100%;
  -webkit-border-radius: 100%;
}
.user span {
  display: inline-block;
  padding-right: 15px;
  line-height: 36px;
  font-size: 14px;
  color: #fff;
  padding-left: 15px;
}
@media screen and (max-width: 1565px) {
  .nav li a {
    padding: 0 5px;
  }
}
@media screen and (max-width: 1345px) {
  .nav a h2 {
    font-size: 14px;
  }
}
@media screen and (max-width: 1254px) {
  .nav a h2 {
    font-size: 12px;
  }
}
@media screen and (max-width: 1164px) {
}
.avatar-box,
.msg-number-box {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.msg-number-box sup.el-badge__content.is-fixed {
  top: 25px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}
</style>
